<div class="margin-top" *transloco="let t">
    <ng-container *ngIf="items != undefined">
        <app-home-about-us-section-b-item [item]="items[0]" [imageFirst]="true"></app-home-about-us-section-b-item>
        <app-home-about-us-section-b-item [item]="items[1]" [imageFirst]="false"></app-home-about-us-section-b-item>
    </ng-container>
</div>